import { allMathematicsWorksheetModuleTypes } from "@arbeidsark/shared"
import type { WorksheetMathematicsModuleType } from "@arbeidsark/shared"
import { Select, type SelectOption, type SelectProps } from "~/components"
import { useTranslate } from "~/ur-react-hooks"

export interface MathematicsTaskTypesProps
  extends Omit<SelectProps<WorksheetMathematicsModuleType | null>, "options"> {}

const MathematicsTaskTypesSelect: React.FC<MathematicsTaskTypesProps> = ({
  ...props
}) => {
  const translations = useTranslate({
    "mathematics/neighbourNumbers":
      "worksheets.task-types.mathematics.neighbourNumbers",
    "mathematics/arithmetic": "worksheets.task-types.mathematics.arithmetic",
    "mathematics/sudoku": "worksheets.task-types.mathematics.sudoku",
    "mathematics/guessTheHouse":
      "worksheets.task-types.mathematics.guessTheHouse",
    "mathematics/numberPatterns":
      "worksheets.task-types.mathematics.numberPatterns",
    "mathematics/numberSeries":
      "worksheets.task-types.mathematics.numberSeries",
    "mathematics/grid": "worksheets.task-types.mathematics.grid",
    "mathematics/sorting": "worksheets.task-types.mathematics.sorting",
    "mathematics/pyramid": "worksheets.task-types.mathematics.pyramid",
    "mathematics/standardAlgorithm":
      "worksheets.task-types.mathematics.standardAlgorithm",
    "mathematics/mathCrossBox":
      "worksheets.task-types.mathematics.mathCrossBox",
    random: "worksheets.labels.random",
  })

  const options: SelectOption<WorksheetMathematicsModuleType>[] =
    allMathematicsWorksheetModuleTypes.map((type) => ({
      value: type,
      label: translations[type],
    }))

  return (
    <Select {...props} options={options} placeholder={translations.random} />
  )
}

export default MathematicsTaskTypesSelect
